<template>
    <div class="advance">
     <img
      src="../../assets/advance/banner.png"
      alt
      style="width:100%;height:22.5rem;overflow:hidden; object-fit: cover;"/>
    <h3>学习提升</h3>
    <div>
       <img
      src="../../assets/advance/img01.png"
      alt
      style="vertical-align:top;width: 40.625rem; height: 27.125rem;"
    />
    <div style="display: inline-block;margin-top: 3rem;margin-bottom: 4.4375rem; text-align: center;">
    <span>
        每一位新员工都有一位资深同事担任导师，<br/>带领新人熟悉公司环境并在工作上给予紧密的谘询<br/>与指导，帮助新人快速融入部门的环境与文化。
    </span>
    </div>
    </div>

  <div style="background-color:#F0F7FC;">
     <h3>职业发展</h3>
     <span>公司建立了弹性的职业发展双通道，<br/>协助员工打造属于自己的发展规划。</span>
     <div> <img
      src="../../assets/advance/img02.png"
      alt
      style="width: 43.375rem;height: 22.625rem;margin-top: 3.625rem;margin-bottom: 4.3125rem;"
    /></div>
  </div>
 </div>
</template>


<style scoped>
.advance{
min-height: 100%;
}


h3{
  padding-top: 3.625rem;
  padding-bottom:2.375rem;
  color: #1A1A1A;
  font-size: 2.25rem;
  line-height: 3.75rem;

}

span{
    color: #777777;
    font-size: 1.5rem;
    line-height: 2.25rem;
}

</style>
<script>
export default {

    data () {
    return {
     msg: '学习发展'
    };
    },
    onActivated (){

    }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/Advance.vue